import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Utils } from '@shared/utils/utils';

import { InvoicesPageService } from '../invoices-page.service';
import { IntegrationLineItem } from '../invoices.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TooltipDirective],
  standalone: true,
  styleUrl: 'detail-cell-renderer.component.scss',
  templateUrl: 'detail-cell-renderer.component.html',
})
export class DetailCellRendererComponent implements ICellRendererAngularComp {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);
  private invoicesPageService = inject(InvoicesPageService);
  private router = inject(Router);

  pinned = signal<string>('');

  lineItems: IntegrationLineItem[] = [];
  params!: ICellRendererParams;
  utils = Utils;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.pinned.set(params.pinned ?? 'center');
    this.invoicesPageService.expandableIntegrationLineItems$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((lineItemList) => {
        this.lineItems =
          lineItemList.find((invoice) => invoice.invoice_id === params.data.id)?.attributes || [];
        this.changeDetectorRef.detectChanges();
      });
  }

  redirectToIntegrationPage(): void {
    const id = this.params.data?.id;

    if (id) {
      void this.router
        .navigate(
          [
            `${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES}/${id}`,
          ],
          { queryParams: { isIntegrationTabActive: true } }
        )
        .catch(console.error);
    }
  }

  refresh(): boolean {
    return false;
  }
}
